"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Pagination = require("../Pagination");

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function SwitchablePagination(_ref) {
  var children = _ref.children,
      enabled = _ref.enabled,
      paginationProps = _objectWithoutPropertiesLoose(_ref, ["children", "enabled"]);

  if (enabled) {
    return _react2.default.createElement(_Pagination2.default, paginationProps, children);
  }

  return children;
}

SwitchablePagination.defaultProps = {
  enabled: false
};
SwitchablePagination.propTypes = {
  currentItemFrom: _propTypes2.default.number,
  currentItemTo: _propTypes2.default.number,
  enabled: _propTypes2.default.bool,
  onNextClick: _propTypes2.default.func,
  onPrevClick: _propTypes2.default.func,
  onRowsChange: _propTypes2.default.func,
  rowsOptions: _propTypes2.default.array,
  textOf: _propTypes2.default.node,
  textShowRows: _propTypes2.default.node,
  totalItems: _propTypes2.default.number
};
exports.default = SwitchablePagination;